import { Subject } from 'rxjs';

export const vehicleCacheBuster$ = new Subject<void>();
